import {Subject} from 'rxjs';

import ErrorType from '../Shared/Constants/ErrorType';
import IConfig   from '../State/Stores/Config/Interfaces/IConfig';

import IMedia from './Interfaces/IMedia';

class ConsumerInput {
    public media$ = new Subject<IMedia>();
    public config$ = new Subject<IConfig>();
    public togglePlayPause$ = new Subject<boolean>();
    public toggleFullscreen$ = new Subject<boolean>();
    public seek$ = new Subject<number>();
    public volume$ = new Subject<number>();
    public toggleControls$ = new Subject<boolean>();
    public error$ = new Subject<ErrorType>();
}

export default ConsumerInput;